import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";
import * as Highcharts from "highcharts";
import { IMyDpOptions } from "mydatepicker";
import { Router } from "@angular/router";
import { checkDate as checkDateUtil } from "../utils/format-util";

declare let require: any;
const Boost = require("highcharts/modules/boost");
const noData = require("highcharts/modules/no-data-to-display");
const More = require("highcharts/highcharts-more");

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
})
export class DashboardComponent implements OnInit {
  public myDatePickerOptions1: IMyDpOptions = {};
  public myDatePickerOptions2: IMyDpOptions = {};
  public myDatePickerOptions3: IMyDpOptions = {};
  public myDatePickerOptions4: IMyDpOptions = {};

  dashboardData = {
    imageCenterCount: 0,
    insuranceCompanyCount: "0",
    patientCount: "0",
    technicianCount: "0",
    doctorCount: "0",
  };
  reservedashboardData = {
    webCount: 0,
    mobileCount: "0",
    imageCenterCount: "0",
    totalSchedmedCount: "0",
  };
  routerName = "";
  disableuntil: any;
  disableuntil1: any;
  startDateFilter: any;
  endDateFilter: any;
  startDateFilter1: any;
  endDateFilter1: any;
  datepickershow = false;
  datepickershow1 = false;
  totalSchedmedCount: any;
  constructor(
    private appService: AppService,
    private supportService: SupportService,
    private location: Location,
    private router: Router
  ) {}
  tcCode: any;
  today = new Date();
  fromDateRange: any;
  toDateRange: any;
  fromDateRange1: any;
  toDateRange1: any;
  dashboardMenuActive = sessionStorage.getItem("dashboardtype")
    ? sessionStorage.getItem("dashboardtype")
    : "total";
  dashboardMenuActive1 = sessionStorage.getItem("dashboardtype1")
    ? sessionStorage.getItem("dashboardtype1")
    : "totalr";

  ngOnInit() {
    this.intialType();
    this.initialType1();

    this.myDatePickerOptions1 = {
      dateFormat: "mmm dd, yyyy",
      firstDayOfWeek: "su",
      showClearDateBtn: false,
      editableDateField: false,
    };

    this.myDatePickerOptions3 = {
      dateFormat: "mmm dd, yyyy",
      firstDayOfWeek: "su",
      showClearDateBtn: false,
      editableDateField: false,
    };

    this.tcCode = localStorage.getItem("testCode");
    this.checkUrl();
  }

  checklngth(value) {
    if (value && value.length > 1) {
      return value;
    } else if (value) {
      return "0" + value;
    }
    return 0;
  }

  intialType() {
    if (sessionStorage.getItem("dashboardtype")) {
      this.dashboardMenuActive = sessionStorage.getItem("dashboardtype");
      if (this.dashboardMenuActive !== "range") {
        this.getDashboardByType(sessionStorage.getItem("dashboardtype"));
      } else {
        if (
          sessionStorage.getItem("startDate") &&
          sessionStorage.getItem("endDate")
        ) {
          this.datepickershow = true;
          const startDatearray = sessionStorage
            .getItem("startDate")
            .toString()
            .split("-");

          if (startDatearray.length > 0) {
            this.fromDateRange = {
              date: {
                year: startDatearray[0],
                month: this.checkDateDigits(startDatearray[1]),
                day: this.checkDateDigits(startDatearray[2]),
              },
            };
          }

          this.disableuntil = {
            day: startDatearray[2],
            month: startDatearray[1],
            year: startDatearray[0],
          };

          this.myDatePickerOptions2 = {
            dateFormat: "mmm dd, yyyy",
            firstDayOfWeek: "su",
            showClearDateBtn: false,
            editableDateField: false,
            showInputField: true,
            inline: false,
            disableUntil: this.disableuntil,
          };

          const endDatearray = sessionStorage
            .getItem("endDate")
            .toString()
            .split("-");
          if (endDatearray.length > 0) {
            this.toDateRange = {
              date: {
                year: endDatearray[0],
                month: this.checkDateDigits(endDatearray[1]),
                day: this.checkDateDigits(endDatearray[2]),
              },
            };
          }

          if (this.fromDateRange && this.toDateRange) {
            const data = {
              startDate: sessionStorage.getItem("startDate"),
              endDate: sessionStorage.getItem("endDate"),
            };
            this.getDashboardCountAdmin(data);
          }
        }
      }
    } else {
      this.getDashboardByType("total");
    }
  }

  initialType1() {
    if (sessionStorage.getItem("dashboardtype1")) {
      this.dashboardMenuActive1 = sessionStorage.getItem("dashboardtype1");
      if (this.dashboardMenuActive1 !== "ranger") {
        this.getReserveDashboardByType(
          sessionStorage.getItem("dashboardtype1")
        );
      } else {
        if (
          sessionStorage.getItem("startDate1") &&
          sessionStorage.getItem("endDate1")
        ) {
          this.datepickershow1 = true;
          const startDatearray = sessionStorage
            .getItem("startDate1")
            .toString()
            .split("-");

          if (startDatearray.length > 0) {
            this.fromDateRange1 = {
              date: {
                year: startDatearray[0],
                month: this.checkDateDigits(startDatearray[1]),
                day: this.checkDateDigits(startDatearray[2]),
              },
            };
          }

          this.disableuntil1 = {
            day: startDatearray[2],
            month: startDatearray[1],
            year: startDatearray[0],
          };

          this.myDatePickerOptions4 = {
            dateFormat: "mmm dd, yyyy",
            firstDayOfWeek: "su",
            showClearDateBtn: false,
            editableDateField: false,
            showInputField: true,
            inline: false,
            disableUntil: this.disableuntil1,
          };

          const endDatearray = sessionStorage
            .getItem("endDate1")
            .toString()
            .split("-");
          if (endDatearray.length > 0) {
            this.toDateRange1 = {
              date: {
                year: endDatearray[0],
                month: this.checkDateDigits(endDatearray[1]),
                day: this.checkDateDigits(endDatearray[2]),
              },
            };
          }

          if (this.fromDateRange1 && this.toDateRange1) {
            const data = {
              startDate: sessionStorage.getItem("startDate1"),
              endDate: sessionStorage.getItem("endDate1"),
            };
            this.getReserveDashboardCountAdmin(data);
          }
        }
      }
    } else {
      this.getReserveDashboardByType("totalr");
    }
  }
  checkDateDigits(value) {
    if (value) {
      if (+value > 9) {
        return +value;
      } else {
        const datelength = value.split("0");
        if (datelength.length > 1) {
          return +datelength[1];
        } else {
          return +datelength;
        }
      }
    }
  }

  checkDate(str) {
    return checkDateUtil(str);
  }

  onDateChanged(event) {
    this.startDateFilter =
      event.date.year +
      "-" +
      this.checkDate(event.date.month) +
      "-" +
      this.checkDate(event.date.day);

    const today = new Date(event.jsdate);
    const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);

    this.disableuntil = {
      day: this.checkDate(yesterday.getDate()),
      month: this.checkDate(yesterday.getMonth() + 1),
      year: yesterday.getFullYear(),
    };

    this.myDatePickerOptions2 = {
      dateFormat: "mmm dd, yyyy",
      firstDayOfWeek: "su",
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: true,
      inline: false,
      disableUntil: this.disableuntil,
    };

    this.toDateRange = "";
    this.endDateFilter = "";
  }

  onDateChanged2(event) {
    this.endDateFilter =
      event.date.year +
      "-" +
      this.checkDate(event.date.month) +
      "-" +
      this.checkDate(event.date.day);

    if (this.startDateFilter && this.endDateFilter) {
      const data = {
        startDate: this.startDateFilter,
        endDate: this.endDateFilter,
      };
      this.getDashboardCountAdmin(data);
    }
  }

  onDateChanged3(event) {
    this.startDateFilter1 =
      event.date.year +
      "-" +
      this.checkDate(event.date.month) +
      "-" +
      this.checkDate(event.date.day);

    const today = new Date(event.jsdate);
    const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);

    this.disableuntil1 = {
      day: this.checkDate(yesterday.getDate()),
      month: this.checkDate(yesterday.getMonth() + 1),
      year: yesterday.getFullYear(),
    };

    this.myDatePickerOptions4 = {
      dateFormat: "mmm dd, yyyy",
      firstDayOfWeek: "su",
      showClearDateBtn: false,
      editableDateField: false,
      showInputField: true,
      inline: false,
      disableUntil: this.disableuntil1,
    };

    this.toDateRange1 = "";
    this.endDateFilter1 = "";
  }

  onDateChanged4(event) {
    this.endDateFilter1 =
      event.date.year +
      "-" +
      this.checkDate(event.date.month) +
      "-" +
      this.checkDate(event.date.day);

    if (this.startDateFilter1 && this.endDateFilter1) {
      const data = {
        startDate: this.startDateFilter1,
        endDate: this.endDateFilter1,
      };
      this.getReserveDashboardCountAdmin(data);
    }
  }

  piechart(webcount, mobilecount, iccount, totalcount) {
    const web = webcount;
    const mobile = mobilecount;
    const ic = iccount;
    const sched = totalcount;
    const total = iccount + totalcount;

    Highcharts.chart("container", {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
      },
      credits: {
        enabled: false,
      },
      title: {
        text: total + "<br>Reservation<br>",
        align: "center",
        verticalAlign: "middle",
        // y: 100
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          colors: ["#55D8FE", "#FF8373"],
          dataLabels: {
            enabled: true,
            distance: -50,
            style: {
              fontWeight: "bold",
              fontSize: "15px",
              color: "white",
            },
            format: "<b>{point.name}</b>",
          },
          startAngle: -360,
          endAngle: 360,
          size: "110%",
        },
      },
      series: [
        {
          type: "pie",
          innerSize: "50%",
          data: [
            {
              name: sched > 0 ? sched : "",
              y: sched > 0 ? sched : 0,
            },
            {
              name: ic > 0 ? ic : "",
              y: ic > 0 ? ic : 0,
            },
          ],
        },
      ],
    });
  }

  piechart2(webcount, mobilecount, iccount, totalcount) {
    const web = webcount;
    const mobile = mobilecount;
    const total = webcount + mobilecount;

    Highcharts.chart("container2", {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
      },
      credits: {
        enabled: false,
      },
      title: {
        text: total + "<br>Schedmed <br> Reservation<br>",
        align: "center",
        verticalAlign: "middle",
        // y: 100
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          colors: ["#B5651D", "#A3A0FB"],
          dataLabels: {
            enabled: true,
            distance: -50,
            style: {
              fontWeight: "bold",
              fontSize: "15px",
              color: "white",
            },
            format: "<b>{point.name}</b>",
          },
          startAngle: -360,
          endAngle: 360,
          size: "110%",
        },
      },
      series: [
        {
          type: "pie",
          innerSize: "50%",
          data: [
            {
              name: web > 0 ? web : "",
              y: web > 0 ? web : 0,
            },
            {
              name: mobile > 0 ? mobile : "",
              y: mobile > 0 ? mobile : 0,
            },
          ],
        },
      ],
    });
  }

  checkUrl() {
    const path = this.location.path().split("/");
    if (path.length === 3) {
      this.routerName = path[2];
    }
  }

  getDashboardByType(type) {
    let data = {};
    sessionStorage.setItem("dashboardtype", type);
    if (type === "total") {
      this.datepickershow = false;
      data = {
        startDate: "",
        endDate: "",
      };
      sessionStorage.removeItem("startDate");
      sessionStorage.removeItem("endDate");
    }
    if (type && type === "year") {
      this.datepickershow = false;
      var year = this.today.getFullYear();
      data = {
        startDate: year + "-01-01",
        endDate: year + "-12-31",
      };
    }

    if (type && type === "month") {
      this.datepickershow = false;
      var year = this.today.getFullYear();
      const month = this.today.getMonth() + 1;
      data = {
        startDate: year + "-" + this.checklngth(month) + "-01",
        endDate: year + "-" + this.checklngth(month) + "-31",
      };
    }

    if (type && type === "range") {
      this.datepickershow = true;
      this.fromDateRange = "";
      this.toDateRange = "";
    }

    if (type !== "range") {
      this.getDashboardCountAdmin(data);
    }
  }

  navigateMethod(type) {
    if (type && type === "1") {
      this.navigateToAdminPage("imaging");
    } else if (type && type === "5") {
      this.navigateToAdminPage("doctor-list");
    } else if (type && type === "4") {
      this.navigateToAdminPage("technologist");
    } else if (type && type === "2") {
      this.navigateToAdminPage("insurance-companies");
    } else if (type && type === "3") {
      this.navigateToAdminPage("patient-list");
    }
  }

  navigateToAdminPage(page: string) {
    const testCode = (localStorage.getItem("testCode") || "").trim();
    if (sessionStorage.getItem("usertype") === "1") {
      if (testCode) {
        this.router.navigateByUrl("/" + testCode + "/admin/" + page);
      } else {
        this.router.navigateByUrl("/admin/" + page);
      }
    } else if (testCode) {
      this.router.navigate([testCode, page]);
    }
  }

  getDashboardCountAdmin(data) {
    if (data && data.startDate && data.endDate) {
      sessionStorage.setItem("startDate", data.startDate);
      sessionStorage.setItem("endDate", data.endDate);
    }
    this.appService.getDashboardCountAdmin(data).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        if (res["entity"]) {
          this.dashboardData = res["entity"];
        } else {
          this.dashboardData = {
            imageCenterCount: 0,
            insuranceCompanyCount: "0",
            patientCount: "0",
            technicianCount: "0",
            doctorCount: "0",
          };
        }
      }
    });
  }

  getReserveDashboardCountAdmin(data) {
    if (data && data.startDate && data.endDate) {
      sessionStorage.setItem("startDate1", data.startDate);
      sessionStorage.setItem("endDate1", data.endDate);
    }
    this.appService.getReserveDashboardCountAdmin(data).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        if (res["entity"]) {
          this.reservedashboardData = res["entity"];
          this.reservedashboardData.totalSchedmedCount =
            res["entity"].webCount + res["entity"].mobileCount;
          this.piechart(
            this.reservedashboardData.webCount,
            this.reservedashboardData.mobileCount,
            this.reservedashboardData.imageCenterCount,
            this.reservedashboardData.totalSchedmedCount
          );
          this.piechart2(
            this.reservedashboardData.webCount,
            this.reservedashboardData.mobileCount,
            this.reservedashboardData.imageCenterCount,
            this.reservedashboardData.totalSchedmedCount
          );
        }
      }
    });
  }

  getReserveDashboardByType(type) {
    let data = {};
    sessionStorage.setItem("dashboardtype1", type);
    if (type === "totalr") {
      this.datepickershow1 = false;
      data = {
        startDate: "",
        endDate: "",
      };
      sessionStorage.removeItem("startDate1");
      sessionStorage.removeItem("endDate1");
    }
    if (type && type === "yearr") {
      this.datepickershow1 = false;
      var year = this.today.getFullYear();
      data = {
        startDate: year + "-01-01",
        endDate: year + "-12-31",
      };
    }

    if (type && type === "monthr") {
      this.datepickershow1 = false;
      var year = this.today.getFullYear();
      const month = this.today.getMonth() + 1;
      data = {
        startDate: year + "-" + this.checklngth(month) + "-01",
        endDate: year + "-" + this.checklngth(month) + "-31",
      };
    }

    if (type && type === "ranger") {
      this.datepickershow1 = true;
      this.fromDateRange1 = "";
      this.toDateRange1 = "";
    }

    if (type !== "ranger") {
      this.getReserveDashboardCountAdmin(data);
    }
  }
}
